import { ForgotPasswordView } from "../components/auth/forgot-password/ForgotPasswordView";
import { BackgroundLayout } from "../layouts/BackgroundLayout";

const ForgotPasswordPage = () => {
  return (
    <BackgroundLayout>
      <ForgotPasswordView />
    </BackgroundLayout>
  );
};

export { ForgotPasswordPage };
